import { Box, Button, Divider, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function Bloque4({ text4, handleDatosTextField4 }) {

    useEffect(()=>{
        console.log(text4)
    }, [text4])

    const [mostrar, setMostrar] = useState(false)

    const handleMostrar = () => {
        setMostrar(!mostrar)
    }

    return (
        <Box style={{ marginTop: "0px" }} >
            {/* <Typography variant="h4" >Amsler Test</Typography> */}

            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography style={{ fontSize: "17px", marginTop: "20px" }} ><b>Amsler Test</b></Typography>
                <Button variant='outlined' style={{ marginTop: "10px" }} onClick={handleMostrar}>{mostrar ? "Ocultar Valores" : "Mostrar Valores"}</Button>
            </Box>

            

            {
                mostrar &&
                <Box style={{ marginTop: "30px", display: "flex", justifyContent: "space-between" }}>

                {
                    text4.map((x, ix) =>
                        <Box key={ix} style={{ marginTop: "10px", width: "580px", marginLeft: "20px" }}>
                            <Box style={{ textAlign: "center" }}>
                                <Typography variant='h5'>{x.label}</Typography>
                            </Box>
                            <TextField
                                label={text4.label}
                                multiline
                                rows={7}
                                fullWidth
                                value={x.valor}
                                onChange={(e) => handleDatosTextField4(x.id, e.target.value, 'valor')}
                            />
                        </Box>
                    )
                }

            </Box>}

            <Divider style={{ marginTop: "15px" }} />

        </Box>
    )
}
